const prependProtocol = (url) => {
    if (url && !/^https?:\/\//i.test(url)) {
        url = 'http://' + url;
    }
    return url;
};
export default prependProtocol;
//# sourceMappingURL=prependProtocol.js.map